Object.defineProperty(exports, "__esModule", { value: true })
exports.DescendantChart = exports.layOutDescendants = exports.DUMMY_ROOT_NODE_ID = void 0

const d3_hierarchy_1 = require("d3-hierarchy")
const chart_util_1 = require("./chart-util")
const id_generator_1 = require("./id-generator")

exports.DUMMY_ROOT_NODE_ID = "DUMMY_ROOT_NODE"


/** Renders a descendants chart. */
const DescendantChart = (function () {

    function DescendantChart(options) {
        this.options = options
        this.util = new chart_util_1.ChartUtil(options)
    }

    DescendantChart.prototype.getNodes = function (id) {
        const _this = this
        const indi = this.options.data.getIndi(id)
        const famIds = indi.getFamiliesAsSpouse()
        // Single person
        if (!famIds.length) return [{ id: id, indi: { id: id } }]
        // Marriages
        const nodes = famIds.map(famId => {
            const fam = _this.options.data.getFam(famId)
            if (!fam || !fam.isEnabled()) return null  // skip disabled families
            const entry = { id: famId, indi: { id: id }, family: { id: famId } }
            const spouse = getSpouse(id, fam)
            if (spouse) {
                const spouseIndi = _this.options.data.getIndi(spouse)
                if (spouseIndi && spouseIndi.isEnabled()) {
                    entry.spouse = { id: spouse }
                }
            }
            return entry
        }).filter(Boolean)

        nodes.slice(1).forEach(function (node) { node.additionalMarriage = true })
        return nodes
    }

    DescendantChart.prototype.getFamNode = function (famId) {
        const node = { id: famId, family: { id: famId } }
        const fam = this.options.data.getFam(famId)
        if (!fam || !fam.isEnabled()) return  // skip disabled families
        const father = fam.getFather()
        if (father) {
            const fatherIndi = this.options.data.getIndi(father)
            if (fatherIndi && fatherIndi.isEnabled()) node.indi = { id: father }
        }
        const mother = fam.getMother()
        if (mother) {
            const motherIndi = this.options.data.getIndi(mother)
            if (motherIndi && motherIndi.isEnabled()) node.spouse = { id: mother }
        }
        return node
    }

    /** Creates a d3 hierarchy from the input data. */
    DescendantChart.prototype.createHierarchy = function () {
        const _this = this;
        const parents = []
        const nodes = this.options.startIndi ? this.getNodes(this.options.startIndi) : [this.getFamNode(this.options.startFam)]
        const idGenerator = this.options.idGenerator || new id_generator_1.IdGenerator()
        nodes.forEach(function (node) { return (node.id = idGenerator.getId(node.id)); })
        // If there are multiple root nodes, i.e. the start individual has multiple marriages, create a dummy root node.
        // After layout is complete, the dummy node will be removed
        if (nodes.length > 1) {
            const dummyNode_1 = { id: exports.DUMMY_ROOT_NODE_ID, height: 1, width: 1 }
            parents.push(dummyNode_1)
            nodes.forEach(function (node) { return (node.parentId = dummyNode_1.id); })
        }
        parents.push.apply(parents, nodes)
        const stack = []
        nodes.forEach(function (node) {
            if (node.family) stack.push(node)
        })
        const _loop_1 = function () {
            const entry = stack.pop()
            const fam = this_1.options.data.getFam(entry.family.id)
            fam.getChildren().forEach(function (childId) {
                const childIndi = _this.options.data.getIndi(childId)
                if (!childIndi || !childIndi.isEnabled())
                    return  // skip disabled children
                const childNodes = _this.getNodes(childId)
                childNodes.forEach(function (node) {
                    node.parentId = entry.id
                    if (node.family) {
                        node.id = "" + idGenerator.getId(node.family.id)
                        stack.push(node)
                    }
                })
                parents.push.apply(parents, childNodes)
            })
        }
        const this_1 = this
        while (stack.length)
            _loop_1()
        return d3_hierarchy_1.stratify()(parents)
    }

    /**
     * Renders the tree, calling the provided renderer to draw boxes for individuals.
     */
    DescendantChart.prototype.render = function () {
        const root = this.createHierarchy()
        const nodes = removeDummyNode(this.util.layOutChart(root))
        const animationPromise = this.util.renderChart(nodes)
        const info = chart_util_1.getChartInfo(nodes)
        this.util.updateSvgDimensions(info)
        return Object.assign(info, { animationPromise: animationPromise })
    }
    return DescendantChart
}())

function layOutDescendants(options, layoutOptions) {
    if (layoutOptions === void 0) layoutOptions = {}
    const descendants = new DescendantChart(options)
    const descendantsRoot = descendants.createHierarchy();
    return removeDummyNode(new chart_util_1.ChartUtil(options).layOutChart(descendantsRoot, layoutOptions))
}
exports.layOutDescendants = layOutDescendants

/** Removes the dummy root node if it was added in createHierarchy(). */
function removeDummyNode(allNodes) {
    if (allNodes[0].id !== exports.DUMMY_ROOT_NODE_ID) return allNodes
    const nodes = allNodes.slice(1)
    // Move first node to (0, 0) coordinates.
    const dx = -nodes[0].x
    const dy = -nodes[0].y;
    nodes.forEach(function (node) {
        if (node.parent && node.parent.id === exports.DUMMY_ROOT_NODE_ID && !node.data.additionalMarriage) node.parent = null
        node.x += dx
        node.y += dy
        node.data.generation--
    })
    return nodes
}

/** Returns the spouse of the individual in the specified family. */
function getSpouse(indiId, fam) {
    if (fam.getFather() === indiId)
        return fam.getMother()
    return fam.getFather()
}
exports.DescendantChart = DescendantChart